import React, { FunctionComponent } from 'react'
import { useTotalAmountPayable } from './hooks'
import { Grid, Text } from '@afterpaytouch/core'
import { Money } from '..'
import { useTranslation } from '../../utils/convergence'
import { useAppRouter, useIsCheckoutLoadingOrUpdating } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'

interface TotalAmountPayableProps {
  orderBreakdownIsHidden?: boolean
  isEstimatedTotal?: boolean
}

export const TotalAmountPayable: FunctionComponent<TotalAmountPayableProps> = ({ orderBreakdownIsHidden = false, isEstimatedTotal = false }) => {
  const { t } = useTranslation()
  const { locale } = useAppRouter()
  const { textSize } = useCheckoutSizes()
  const loading = useIsCheckoutLoadingOrUpdating()
  const totalAmountPayable = useTotalAmountPayable(orderBreakdownIsHidden)

  if (typeof totalAmountPayable === 'undefined') {
    return null
  }

  const i18nKey = isEstimatedTotal ? 'orders:orderSummary.estimatedTotal' : 'orders:orderSummary.totalAmountPayable'

  return (
    <Grid justifyContent='space-between'>
      <Grid.Item>
        <Text size={textSize} testNameSpace='total-amount-payable'>
          {t(i18nKey)}
        </Text>
      </Grid.Item>
      <Grid.FixedItem align='right'>
        <Money
          showAsterisk={isEstimatedTotal}
          loading={loading}
          locale={locale}
          size={textSize}
          value={totalAmountPayable}
          testNameSpace='total-amount-payable'
        />
      </Grid.FixedItem>
    </Grid>
  )
}
